import React from 'react'

import Footer from '../../app/components/Common/Footer'
import Header from '../../app/components/Common/Header'

const SingleLayout = ({ children }) => {
  return (
    <div className="bg-lightGray">
      <Header />
      <main className="mx-auto min-h-[calc(75vh-56px)">{children}</main>
      <Footer />
    </div>
  )
}

export default SingleLayout
